export const ProductsList = () => {
  const form = document.querySelector('#products-list')
  const markAsDeliveredBtn = document.querySelector('[mark-as-delivered-btn]')
  const markAsDeliveredForm = document.querySelector('[mark-as-delivered-form]')
  const code = form.querySelector('[name="code"]')

  if (!form) return

  markAsDeliveredForm.addEventListener('submit', e => {
    e.preventDefault()
    code.value = markAsDeliveredForm.querySelector('[name="code"]').value
    form.submit()
    return
  })

  markAsDeliveredBtn.addEventListener('click', e => {
    code.value = markAsDeliveredForm.querySelector('[name="code"]').value
    form.submit()
    return
  })
}
